import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { hasLinksInSelection, LinkButton, getModalStyles, EditorModals } from 'wix-rich-content-editor-common';
import { LINK_TYPE } from '../types.js';
import { isEmpty } from 'lodash';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class TextLinkButton extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "showLinkPanel", () => {
      var _a;
      const { getEditorState, setEditorState, getEntityData, insertCustomLink, config } = this.props;
      const settings = config[LINK_TYPE];
      const onLinkAdd = settings == null ? void 0 : settings.onLinkAdd;
      const isCustomLinkHandling = onLinkAdd;
      if (isCustomLinkHandling) {
        const customLinkData = (_a = getEntityData(getEditorState())) == null ? void 0 : _a.customData;
        const callback = (data) => setEditorState(insertCustomLink(getEditorState(), data));
        onLinkAdd(customLinkData, callback);
      } else {
        this.openLinkPanel();
      }
    });
    __publicField(this, "openLinkPanel", () => {
      const {
        getEditorState,
        setEditorState,
        theme,
        isMobile,
        linkModal,
        helpers,
        keyName,
        anchorTarget,
        relValue,
        t,
        uiSettings,
        insertLinkFn,
        closeInlinePluginToolbar,
        config,
        innerModal,
        toolbarOffsetTop,
        toolbarOffsetLeft
      } = this.props;
      const settings = config[LINK_TYPE];
      const linkTypes = settings == null ? void 0 : settings.linkTypes;
      const OriginalLinkPanel = !linkTypes || isEmpty(linkTypes) || !Object.values(linkTypes).find((addon) => !!addon);
      const { externalPopups = false } = uiSettings.linkPanel || {};
      const customStyles = !isMobile && !OriginalLinkPanel ? {
        content: {
          width: 512,
          maxWidth: 512,
          height: 390,
          border: "1px solid rgb(237, 237, 237)",
          borderRadius: "var(--ricos-settings-whitebox-border-radius, 6px)",
          boxShadow: "var(--ricos-settings-whitebox-box-shadow, rgba(0, 0, 0, 0.07) 0px 4px 8px 0px)",
          padding: 20
        }
      } : {
        content: {
          position: "fixed"
        }
      };
      const modalStyles = getModalStyles({
        fullScreen: isMobile,
        isMobile,
        customStyles
      });
      const commonPanelProps = {
        helpers,
        modalName: EditorModals.TEXT_LINK_MODAL,
        anchorTarget,
        relValue,
        theme,
        t,
        uiSettings,
        getEditorState,
        setEditorState,
        insertLinkFn,
        closeInlinePluginToolbar,
        linkTypes
      };
      if (externalPopups || isMobile || linkModal) {
        if (helpers && helpers.openModal) {
          const modalProps = __spreadValues({
            modalStyles,
            hidePopup: helpers.closeModal,
            isMobile
          }, commonPanelProps);
          helpers.openModal(modalProps);
        } else {
          console.error(
            "Open external helper function is not defined for toolbar button with keyName " + keyName
          );
        }
      } else {
        const modalProps = __spreadValues({
          hidePopup: innerModal.closeInnerModal,
          top: toolbarOffsetTop,
          left: toolbarOffsetLeft,
          modalStyles: OriginalLinkPanel ? null : { maxWidth: "none", padding: 20 }
        }, commonPanelProps);
        innerModal.openInnerModal(modalProps);
      }
    });
  }
  get isActive() {
    return hasLinksInSelection(this.props.getEditorState());
  }
  render() {
    var _a, _b, _c;
    const { theme, helpers, isMobile, tabIndex, config, isActive, icon, tooltipText, disabled } = this.props;
    const buttonStyles = {
      button: theme.inlineToolbarButton,
      buttonWrapper: theme.inlineToolbarButton_wrapper,
      icon: theme.inlineToolbarButton_icon,
      active: theme.inlineToolbarButton_active
    };
    const insertLinkIcon = ((_c = (_b = (_a = config == null ? void 0 : config.LINK) == null ? void 0 : _a.toolbar) == null ? void 0 : _b.icons) == null ? void 0 : _c.InsertPluginButtonIcon) || icon;
    return /* @__PURE__ */ React.createElement(
      LinkButton,
      {
        onClick: this.showLinkPanel,
        isActive,
        helpers,
        theme: __spreadValues(__spreadValues({}, theme), buttonStyles),
        isMobile,
        tooltipText,
        tabIndex,
        pluginType: LINK_TYPE,
        icon: insertLinkIcon,
        disabled
      }
    );
  }
}
TextLinkButton.propTypes = {
  getEditorState: PropTypes.func.isRequired,
  setEditorState: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  linkModal: PropTypes.bool,
  helpers: PropTypes.object,
  keyName: PropTypes.string,
  anchorTarget: PropTypes.string,
  relValue: PropTypes.string,
  t: PropTypes.func,
  tabIndex: PropTypes.number,
  uiSettings: PropTypes.object,
  config: PropTypes.object,
  isActive: PropTypes.bool,
  insertLinkFn: PropTypes.func,
  icon: PropTypes.func,
  closeInlinePluginToolbar: PropTypes.func,
  tooltipText: PropTypes.string,
  innerModal: PropTypes.object,
  toolbarOffsetTop: PropTypes.string,
  toolbarOffsetLeft: PropTypes.string,
  getEntityData: PropTypes.func,
  insertCustomLink: PropTypes.func,
  disabled: PropTypes.bool
};

export { TextLinkButton as default };
//# sourceMappingURL=TextLinkButton.js.map
